import { TfiClose } from 'react-icons/tfi'; // assuming you're using this icon

const TaskViewModal = ({ isOpen, onClose, item }) => {
  if (!isOpen || !item) return null;

  // Define which fields you want to show + their display labels
  const fieldConfig = [
    { key: "id", label: "ID" },
    { key: "userid", label: "User ID" },
    { key: "story_id", label: "Story ID" },
    { key: "story_title", label: "Story Title (Source)" },
    { key: "srcLang", label: "Source Language" },
    { key: "tgtLang", label: "Target Language" },
    { key: "engine", label: "Translation Engine" },
    { key: "status", label: "Status" },
    { key: "created_at", label: "Create Date" },
    { key: "updated_at", label: "Update Date" },


    // Add more fields that exist in your item object
    // { key: "status",        label: "Status" },
    // { key: "priority",      label: "Priority" },
    // { key: "assigned_to",   label: "Assigned To" },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-bold text-gray-900">Task Details</h3>
          <button
            onClick={onClose}
            className="text-gray-700 hover:text-gray-900"
            title="Close"
          >
            <TfiClose size={28} className="font-extrabold" />
          </button>
        </div>

        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 px-5 py-3 text-left text-lg font-bold text-gray-900">
                Field
              </th>
              <th className="border border-gray-300 px-5 py-3 text-left text-lg font-bold text-gray-900">
                Value
              </th>
            </tr>
          </thead>
          <tbody>
            {fieldConfig.map(({ key, label }) => (
              <tr key={key} className="hover:bg-gray-50">
                <td className="border border-gray-300 px-5 py-3 text-base font-semibold text-gray-800">
                  {label}
                </td>
                <td className="border border-gray-300 px-5 py-3 text-base text-gray-900 break-words">
                  {item[key] !== undefined && item[key] !== null
                    ? item[key]
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2.5 rounded-md font-medium shadow-sm transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskViewModal;